"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitConditionTrue = undefined;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var waitConditionTrue = exports.waitConditionTrue = function waitConditionTrue(condition, interval) {
  return new _bluebird2.default(function (resolve) {
    var check = function check() {
      if (condition()) {
        resolve();
      } else {
        setTimeout(check, interval);
      }
    };
    check();
  });
};